export const FormItemTypes = {
  area: 'area',
  question: 'question',
};



// WEBPACK FOOTER //
// ./src/models/survey/FormItemTypes.js